export const loadScript = ({
  onError,
  scriptSrc,
}: {
  scriptSrc: string;
  onError: () => void;
}) =>
  new Promise<void>((resolve, reject) => {
    const scriptElem = Object.assign(document.createElement('script'), {
      type: 'text/javascript',
      defer: true,
      src: scriptSrc,
      onerror: (e: unknown) => {
        reject(e);
        onError();
      },
    });
    scriptElem.onload = () => {
      resolve();
    };
    document.body.appendChild(scriptElem);
  });
